import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { Spinner, Box, Center } from '@chakra-ui/react';

const ProtectedRoute = ({ children, ...props }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        bg="white"
        zIndex="9999"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Center>
          <Spinner size="xl" color="blue.500" />
        </Center>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Redirect to="/auth/signin" />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
